const en = {
  // NAV / HEADER
  "nav.home": "Home",
  "nav.catalog": "Catalog",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.cart": "Cart",

  // HERO
  "hero.title.pre": "Your Next",
  "hero.title.highlight": "Electric Vehicle",
  "hero.title.post": "Is Waiting",
  "hero.subtitle": "Discover our selection of electric vehicles and e-bikes. Quality guaranteed, financing available.",
  "hero.cta.explore": "View Catalog",
  "hero.cta.finance": "Financing",
  "hero.feature.quality": "Quality Guaranteed",
  "hero.feature.warranty": "Extended Warranty",
  "hero.feature.service": "Technical Service",

  // CATALOG / PRODUCT
  "product.more": "See more",
  "product.price": "Price",
  "product.condition.new": "New",
  "product.condition.used": "Used",

  "catalog.title": "Our Catalog",
  "catalog.subtitle": "Explore our selection of electric vehicles, scooters and e-bikes.",
  "catalog.filter.all": "All",
  "catalog.filter.new": "New",
  "catalog.cta.moreBikes": "See More Vehicles",
  "catalog.toast.moreSoon": "More vehicles coming soon. Contact us to see the full inventory!",
  "product.badge.featured": "Featured",
  "product.viewDetails": "View Details",
  "cart.add": "Add",
  "product.price.toConfirm": "Price to confirm",
  "image.altFallback": "Image not available",

  // MODAL
  "modal.close": "Close modal",
  "modal.year": "Year",
  "modal.engine": "Engine",
  "modal.mileage": "Mileage",
  "modal.features": "Features",
  "modal.price": "Price",
  "modal.contact": "Contact",
  "modal.financing": "Financing",
  "modal.whatsapp": "WhatsApp us",

  "guarantee.warranty": "Warranty",
  "guarantee.service": "Service",
  "guarantee.quality": "Quality",

  // CONTACT
  "contact.title": "Contact us",
  "contact.whatsapp": "WhatsApp",
  "contact.call": "Call",
  "contact.email": "Email",
  "contact.subtitle": "Have a question or want to book an appointment? We’re here to help.",
  "contact.info.title": "Contact Information",
  "contact.info.address": "Address",
  "contact.info.phone": "Phone",
  "contact.info.email": "Email",
  "contact.info.hours": "Hours",
  "contact.info.hoursValue": "Mon - Sat: 10:00 AM - 7:30 PM\nSun: 10:00 AM - 6:00 PM",

  "contact.map.title": "Visit Our Store",
  "contact.map.subtitle": "We’re located in the heart of the city with easy public transport access.",
  "contact.map.cta": "View on Google Maps",

  "contact.whats.cta": "Chat with us on WhatsApp!",

  "contact.form.title": "Send us a Message",
  "contact.form.success": "Thanks! Your message was sent.",
  "contact.form.error": "We couldn’t send your message. Please try again.",
  "contact.form.firstName": "First name",
  "contact.form.firstName.placeholder": "Your first name",
  "contact.form.lastName": "Last name",
  "contact.form.lastName.placeholder": "Your last name",
  "contact.form.phone": "Phone",
  "contact.form.phone.hint": "numbers only",
  "contact.form.reason": "Contact Reason",
  "contact.form.reason.info": "Info about vehicles",
  "contact.form.reason.finance": "Financing",
  "contact.form.reason.service": "Technical service",
  "contact.form.reason.warranty": "Warranty",
  "contact.form.reason.other": "Other",
  "contact.form.message": "Message",
  "contact.form.message.placeholder": "Tell us how we can help…",
  "contact.form.submit": "Send Message",
  "contact.form.sending": "Sending…",
  "contact.form.sla.title": "Fast response:",
  "contact.form.sla.body": "We aim to reply to all messages within 24 business hours.",

  "contact.errors.firstNameRequired": "First name is required",
  "contact.errors.lastNameRequired": "Last name is required",
  "contact.errors.emailRequired": "Email is required",
  "contact.errors.emailInvalid": "Invalid email",
  "contact.errors.phoneRequired": "Phone is required",
  "contact.errors.phoneInvalid": "Invalid phone (10–15 digits)",
  "contact.errors.messageRequired": "Message is required",

  // FOOTER
  "footer.rights": "All rights reserved",
  "footer.tagline": "Electric Vehicles & E-Bikes",
  "footer.desc": "Your trusted store for electric vehicles, scooters, and e-bikes. Over 15 years delivering quality, service, and the best prices.",
  "footer.quickLinks.title": "Quick Links",
  "footer.services.title": "Services",
  "services.new": "New Vehicles",
  "services.used": "Used Vehicles",
  "services.finance": "Financing",
  "services.tech": "Technical Service",
  "footer.legal.terms": "Terms & Conditions",
  "footer.legal.privacy": "Privacy Policy",
  "footer.legal.cookies": "Cookies",
  "footer.legal.termsMsg": "Terms & Conditions: Document in progress. For more information, please contact us.",
  "footer.legal.privacyMsg": "Privacy Policy: Document in progress. For more information, please contact us.",
  "footer.legal.cookiesMsg": "Cookies Policy: Document in progress. For more information, please contact us.",
  "social.facebook": "Facebook",
  "social.instagram": "Instagram",
  "social.twitter": "Twitter",
  "social.youtube": "YouTube",

  // GENÉRIC FEATURES
  "feature.motor": "Electric motor",
  "feature.lightAgile": "Light & agile",
  "feature.batteryHigh": "High-capacity battery",
  "feature.motorHighPower": "High-power electric motor",
  "feature.touchscreen": "Touchscreen",
  "feature.bluetooth": "Bluetooth connectivity",
  "feature.gps": "GPS navigation system",
  "favorites.add": "Add to favorites",
  "favorites.remove": "Remove from favorites",


  // EXTRAS POR ID (si los usás)
  "product.8.desc": "Electric scooter: Italian excellence. Power, style and exclusivity in one vehicle.",
  "product.8.feature.0": "ABS",
  "product.8.feature.1": "Traction control",
  "product.8.feature.2": "Riding modes",
  "product.8.feature.3": "Öhlins suspension",
  "product.8.feature.4": "Termignoni exhaust",

  "cart.title": "Your cart",
  "cart.empty": "You haven’t added any products.",
  "cart.total": "Total",
  "cart.clear": "Clear",
  "cart.payWithAffirm": "Pay with Affirm",
  "cart.remove": "Remove",
  "cart.minus": "Decrease",
  "cart.plus": "Increase",

  // ABOUT
  "about.title": "About Us",
  "about.subtitle": "With over 15 years of experience, we’re the most trusted electric vehicle store in the region. We offer quality, service, and competitive prices.",
  "about.stats.years": "Years of Experience",
  "about.stats.clients": "Satisfied Customers",
  "about.stats.support": "Technical Support",
  "about.stats.quality": "Quality Guarantee",
  "about.trust.title": "Your Trust is Our Priority",
  "about.trust.p1": "At ONE POINT MOTORS, we make choosing your electric vehicle easy—from selection to after-sales service.",
  "about.trust.p2": "Our expert team helps you find the perfect vehicle for your needs and budget. We offer flexible financing and extended warranties for peace of mind.",
  "about.chips.quality": "Guaranteed Quality",
  "about.chips.prices": "Competitive Prices",
  "about.chips.service": "Professional Service",
  "about.gallery.alt": "Our store",
  "about.gallery.prev": "Previous image",
  "about.gallery.next": "Next image",
  "about.gallery.seeImage": "See image {{n}}",
  "about.services.title": "Our Services",
  "about.services.new.title": "New Electric Vehicles",
  "about.services.new.desc": "Wide selection from top brands with full warranty.",
  "about.services.used.title": "Certified Used Vehicles",
  "about.services.used.desc": "Inspected and certified vehicles with extended warranty.",
  "about.services.fin.title": "Flexible Financing",
  "about.services.fin.desc": "Financing options tailored to your budget and needs.",
  "about.services.tech.title": "Technical Service",
  "about.services.tech.desc": "Specialized workshop with certified technicians and original parts.",
  "about.services.moreInfo": "More information about: {{title}}. Contact us for details!",

  // MISC
  "common.loading": "Loading..."
} as const;

export default en;
export type EnDict = typeof en;
